import { analyzeWorkflows, getWorkflowAnalysis } from '@/api/workflowAnalysis';
import { setWorkflowIssues } from '@/store/workflowsAnalysis/slice';
import { WorkflowType } from 'src/enums/EWorkflow';

export { getWorkflowAnalysis } from '@/api/workflowAnalysis';

export const fetchAndUpdateWorkflowAnalysis = async (dispatch: any, agentId: string) => {
	try {
		const workflowData = await getWorkflowAnalysis({ agentId });
		dispatch(
			setWorkflowIssues({
				conflicts: workflowData.conflicts || [],
				improvements: workflowData.improvements || [],
			}),
		);

		return workflowData;
	} catch (error) {
		console.error('Error fetching workflow analysis:', error);
	}
};

export const analyzeAndUpdateWorkflow = async (
	currentWorkflow: any,
	workflowType: WorkflowType,
	dispatch: any,
	agentId: string,
) => {
	try {
		const analysisResult = await analyzeWorkflows({
			workflow: currentWorkflow,
			workflowType,
			agentId,
		});

		if (analysisResult) {
			await fetchAndUpdateWorkflowAnalysis(dispatch, agentId);
		}
	} catch (error) {
		console.error('Error analyzing workflow:', error);
	}
};
